import React, { SVGProps } from 'react';

export const ContentIcon = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      className={className ? className : 'w-6 h-6'}
      {...props}
    >
      <path
        fill="currentColor"
        d="m18.706 6.342-1 7.15c-.217 1.5-1.042 2.291-2.4 2.291-.108 0-.225-.008-.342-.016.025-.159.034-.317.034-.492V8.05c0-1.475-.734-2.217-2.217-2.217H4.473c0-.016.008-.041.008-.058l.2-1.4c.117-.85.442-1.475.942-1.858.508-.375 1.191-.508 2.041-.392l8.8 1.233c.842.125 1.467.442 1.85.95.384.5.517 1.192.392 2.034Z"
      />
      <path
        fill="currentColor"
        d="M12.779 5.832h-8.89c-1.482 0-2.222.74-2.222 2.222v7.224c0 1.481.74 2.222 2.222 2.222h8.89c1.482 0 2.223-.74 2.223-2.222V8.054c0-1.482-.74-2.222-2.223-2.222Z"
        opacity=".4"
      />
      <path
        fill="currentColor"
        d="m13.677 12.477-2.594-2.602a.755.755 0 0 0-1.05 0l-3.658 3.658a.373.373 0 0 1-.525 0l-.692-.691a.74.74 0 0 0-1.05 0L2.99 13.96a.251.251 0 0 0-.074.177v1.138c0 .792.184.975.976.975h8.891c.784 0 .967-.183.967-.975v-2.622a.247.247 0 0 0-.073-.176ZM5.418 10.417a.836.836 0 0 1-.835-.834c0-.46.37-.833.829-.833h.006a.833.833 0 0 1 0 1.667Z"
      />
    </svg>
  );
};
